import { render, staticRenderFns } from "./messageBaseModal.vue?vue&type=template&id=4ebd27cd"
import script from "./messageBaseModal.vue?vue&type=script&lang=js"
export * from "./messageBaseModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports